module.exports = __webpack_public_path__ + "static/media/icon-key.e79c2524.svg";